/* Švelna dovanų kuponas: the one coupon renderer. The funnel preview and the
   gift card page (templates/gift_card.dovanu-kuponas.liquid) both call
   SvelnaKuponas.render(el, data), so the preview and the printed A4 never drift. */
(() => {
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const DESIGNS = { klasikinis: 'kp--klasikinis', elegantiskas: 'kp--elegantiskas', kaledinis: 'kp--kaledinis', minimalus: 'kp--minimalus' };
  const T = {
    lt: { title: 'Dovanų kuponas', nr: 'Nr.', gift: 'Dovana', card: 'Dovanų kortelė', how: 'Kaip atsiimti?',
      s1: 'Užeikite į svelna.lt/dovana', s2: 'Įveskite kodą ir išsirinkite dydį bei spalvas', s3: 'Kojinės atkeliaus per 7-14 d. d.',
      s3b: 'Kojinės jau pakeliui pas dovanotoją', s2card: 'Išsirinkite kojines svelna.lt, kodą įveskite atsiskaitant',
      code: 'Kodas', valid: 'Galioja iki', codeSoon: 'Kodą rasite el. laiške', footer: 'Švelnumas kiekvienai dienai',
      contact: 'info@svelna.lt · svelna.lt', story: 'Bambukinės kompresinės kojinės plačioms blauzdoms. Minkštos, kvėpuojančios, be spaudimo.' },
    pl: { title: 'Bon podarunkowy', nr: 'Nr', gift: 'Prezent', card: 'Karta podarunkowa', how: 'Jak odebrać?',
      s1: 'Wejdź na svelna.pl/dovana', s2: 'Wpisz kod i wybierz rozmiar oraz kolory', s3: 'Skarpety dotrą w ciągu 7-14 dni roboczych',
      s3b: 'Skarpety są już w drodze do darczyńcy', s2card: 'Wybierz skarpety na svelna.pl, kod wpisz przy płatności',
      code: 'Kod', valid: 'Ważny do', codeSoon: 'Kod znajdziesz w e-mailu', footer: 'Delikatność na każdy dzień',
      contact: 'info@svelna.lt · svelna.pl', story: 'Bambusowe skarpety uciskowe na szersze łydki. Miękkie, oddychające, bez ucisku.' }
  };
  function render(el, d) {
    if (!el) return;
    const t = T[d.lang === 'pl' ? 'pl' : 'lt'];
    const cls = DESIGNS[d.design] || DESIGNS.klasikinis;
    const isCard = d.type === 'suma';
    const line = isCard ? (t.card + ' · ' + esc(d.amountLabel || '')) : esc(d.line || '');
    const name = (d.name || '').trim();
    const wish = (d.wish || '').trim();
    const steps = isCard
      ? [t.s1, t.s2card, t.s3]
      : [t.s1, t.s2, d.mode === 'B' ? t.s3b : t.s3];
    el.className = 'kp ' + cls + (d.print ? ' kp--print' : '');
    el.innerHTML =
      '<div class="kp__sheet">' +
        '<header class="kp__head">' +
          '<span class="kp__logo" aria-label="Švelna">Švelna</span>' +
          '<span class="kp__nr">' + esc(t.title) + (d.number ? ' ' + esc(t.nr) + ' ' + esc(d.number) : '') + '</span>' +
        '</header>' +
        '<div class="kp__band" role="img" aria-label=""' + (d.image ? ' style="background-image:url(' + esc(d.image) + ')"' : '') + '><span class="kp__band-line">' + line + '</span></div>' +
        '<div class="kp__body">' +
          '<p class="kp__to">' + esc(t.gift) + (name ? ' <strong>' + esc(name) + '</strong>' : '') + '</p>' +
          (wish ? '<p class="kp__wish">„' + esc(wish) + '“</p>' : '<p class="kp__wish kp__wish--empty"></p>') +
          '<p class="kp__story">' + esc(t.story) + '</p>' +
          '<div class="kp__how"><p class="kp__how-h">' + esc(t.how) + '</p><ol>' + steps.map((s, i) => '<li><span>0' + (i + 1) + '</span>' + esc(s) + '</li>').join('') + '</ol></div>' +
          '<div class="kp__code"><span class="kp__code-l">' + esc(t.code) + '</span><span class="kp__code-v">' + (d.code ? esc(d.code) : '<em>' + esc(t.codeSoon) + '</em>') + '</span></div>' +
          '<div class="kp__meta">' + (d.validUntil ? '<span>' + esc(t.valid) + ' ' + esc(d.validUntil) + '</span>' : '<span></span>') + '<span>' + esc(t.contact) + '</span></div>' +
        '</div>' +
        '<footer class="kp__foot">' + esc(t.footer) + '</footer>' +
      '</div>';
  }
  window.SvelnaKuponas = { render, designs: Object.keys(DESIGNS) };
})();
